import React from 'react'

import { config, useSpring } from 'react-spring'
import { AnimatedBox } from '../elements'
import { Link } from "gatsby"
import styled from 'styled-components'

const PostFeed = styled(AnimatedBox)` 
position: relative;
display: flex;
flex-wrap: wrap;
padding: 20px 0 0 0;
`

const TagsUl = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  text-align: left;
`

const Tags = styled.li`
  display: inline-block;
  padding-right: 25px;
  text-transform: uppercase;
}
`

const TagLink = styled(Link)`
  text-decoration: none;
`

export default () => (
      <AnimatedBox py={[6, 6, 6, 8]} px={[6, 6, 8, 6, 8, 13]}>
        <h1>Conrad's Sharing Space ✍🏻</h1>
        <p>
          I write about <strong>innovative new ways</strong> to <strong>solve everyday challenges</strong>. Be the first to be notified when articles, templates, and guides are released by <Link to="/blog/#mailingList">subscribing to our mailing list</Link> 👇.
          </p>
        </AnimatedBox>
        
)